<template>
  <div class="personal">
    <Nav @mobile="mobile" ref="nevRef" />
    <div style="height: 80px"></div>
    <div class="personal-bottom">
      <div class="personal-bottom-bottom">
        <div class="personal-bottom-bottom-left">
          <slide @change="changeSlide"></slide>
        </div>
        <div class="personal-bottom-bottom-right">
          <div class="personal-bottom-bottom-right-top">
            <el-breadcrumb class="daohang" separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/personalc' }">
                <span>我的位置</span>
              </el-breadcrumb-item>
              <el-breadcrumb-item>粉丝群</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <el-divider></el-divider>
          <div class="contentpage">
            <div class="title_box">
              <span class="lines"></span>
              <span>我的粉丝群</span>
            </div>
            <!-- 判断他是不是主播  他有没有创建过粉丝群 -->
            <div class="myfans" v-if="!iscreateFansGroup">
              <span>你还未创建粉丝群、赶紧去创建属于你的粉丝</span>
              <div class="addfanGroup" @click="alert_order_details = true">
                创建粉丝群
              </div>
            </div>
            <div class="fansGroupbox" style="margin-bottom: 24px;">
              <div class="fansGroup_item" @click="alert_order_seal = true" v-for="(items,index) in fansGroupList" :key="index">
                <div class="fans_header">
                  <img style="border-radius: 50%;" :src="items.showImg" alt="" srcset="">
                </div>
                <div class="group_box">
                  <div class="group_title">
                    {{items.title}} ({{items.haveNums}}/{{items.limitNums}}人）
                    <div class="discriptmsg">
                      群公告：{{items.introduction}}
                    </div>
                  </div>
                  <div class="addgroupgreeds" v-if="items.entryCondition">
                    加入群条件：{{fifadduser(items)}}
                  </div>
                </div>
                <!-- 悬浮 -->
               <!-- <div class="appContent"  @click="downloadApp"  v-if="showdownAppindex == items.groupId">
                  请去APP上进行互动
                </div> -->
              </div>
            </div>
            <div class="title_box">
              <span class="lines"></span>
              <span>粉丝群列表</span>
            </div>
            <div class="fansGroupbox" style="padding-bottom: 24px;">
              <div class="fansGroup_item" @click="alert_order_seal = true" v-for="(items,index) in nofansGroupList" :key="index">
                <div class="fans_header">
                  <img :src="items.showImg" style="border-radius: 50%;" alt="" srcset="">
                </div>
                <div class="group_box">
                  <div class="group_title">
                    {{items.title}} ({{items.haveNums}}/{{items.limitNums}}人）
                    <div class="discriptmsg">
                      群公告：{{items.introduction}}
                    </div>
                  </div>
                  <div class="addgroupgreeds" v-if="items.entryCondition">
                    加入群条件：{{fifadduser(items)}}
                  </div>
                </div>
                <!-- 悬浮 -->
               <!-- <div class="appContent" @click="downloadApp"  v-if="showdownAppindex == items.groupId">
                  请去APP上进行互动
                </div> -->
              </div>
            </div>
          </div>

        </div>
        <!-- 结单 -->
        <div class="mask_bg" v-if="alert_order_over">
          <div class="push_order_add" style="padding:22px 0 0;">
            <div class="order_headers" style="padding: 0 22px;">
              <div>结单</div>
              <div class="close_add_order"><img @click="alert_order_over = false" class="tracqCss"
                  src="https://oss.ansongqiubo.com/Image/priceImage/guanbi.png" alt="" /></div>
            </div>
            <div class="ptitles" style="font-weight: 400;padding: 0 22px;">
              您发布的 <span style="color:#721EDC;">{{fanganContent.title}}</span> 推单的结果是：
            </div>
            <div class="order_status" style="padding: 0 22px;">
              <div class="statusImg" @click="checkOrderIndex = 1" :class="checkOrderIndex==1?'checkOrderdefault':''">
                <img src="https://oss.ansongqiubo.com/assets/roomlive/order_hong.png" alt="" srcset="">
              </div>
              <div class="statusImg" @click="checkOrderIndex = 2" :class="checkOrderIndex==2?'checkOrderdefault':''">
                <img src="https://oss.ansongqiubo.com/assets/roomlive/order_zou.png" alt="" srcset="">
              </div>
              <div class="statusImg" @click="checkOrderIndex = 3" :class="checkOrderIndex==3?'checkOrderdefault':''">
                <img src="https://oss.ansongqiubo.com/assets/roomlive/order_ hei.png" alt="" srcset="">
              </div>
            </div>
            <div class="source_button" style="border-top: 1px solid rgba(0, 0, 0, 0.1);margin-top: 38px;">
              <div class="source_cencal" @click="alert_order_over = false">
                取消
              </div>
              <div class="source_ok" style="color: #000;" @click="overorderStatus">
                确认
              </div>
            </div>
          </div>
        </div>
        <!--提示确认封单 -->
        <div class="mask_bg" v-if="alert_order_seal">

          <div class="sael_order">
            <div class="close_downApp">
              <img @click="alert_order_seal = false" class="tracqCss" src="https://oss.ansongqiubo.com/Image/priceImage/guanbi.png"
                alt="" />
            </div>
            <div class="s_title">
              请去APP上进行互动
            </div>
            <div class="s_btn">
            <!--  <span @click="alert_order_seal = false">
                取消
              </span> -->
              <span @click="" @click="downloadApp" style="background: #721EDC;color: #fff;">
                确定
              </span>
            </div>
          </div>
        </div>

        <div class="mask_bg" v-if="alert_order_details">
          <div class="push_order_add">
            <div class="order_headers">
              <div>创建粉丝群</div>
              <div class="close_add_order">
                <img @click="alert_order_details = false" class="tracqCss" src="https://oss.ansongqiubo.com/Image/priceImage/guanbi.png"
                  alt="" />
              </div>
            </div>
            <div class="order_box">
              <div class="add_group_item">
                <div class="names">
                  群昵称
                </div>
                <div class="inputval">
                  <input type="text" v-model="FormData.title" maxlength="10" placeholder="请输入群名称">
                </div>
              </div>
              <div class="message_small">
                *粉丝群一旦创建成功，一月只能修改一次群
              </div>
              <div class="add_group_item" style="align-items: flex-start;">
                <div class="names" style="padding-top: 12px;">
                  群公告
                </div>
                <div class="inputval">
                  <textarea v-model="FormData.introduction" type="text" maxlength="30" placeholder="请输入群公告"></textarea>
                </div>
              </div>
              <div class="add_group_item">
                <div class="names">
                  申请条件
                </div>
                <div class="inputval">
                  <el-select v-model="FormData.entryCondition" placeholder="请选择">
                    <el-option v-for="item in sheetData[0].sheetlist" :key="item.value" :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="add_group_item" v-if="FormData.entryCondition == 3">
                <div class="names">
                  最低等级
                </div>
                <div class="inputval">
                  <el-select v-model="FormData.entryConditionValue" placeholder="请选择">
                    <el-option v-for="item in sheetData[1].sheetlist" :key="item.value" :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="add_group_item">
                <div class="names">
                  通知粉丝
                </div>
                <div class="inputval">
                  <el-switch v-model="switchvalue" active-color="#13ce66" inactive-color="#ff4949">
                  </el-switch>
                </div>
              </div>
              <div class="add_group_item" style="align-items: flex-start;">
                <div class="names" style="padding-top: 12px;">
                  个性化图片
                </div>
                <div class="">
                  <el-upload class="avatar-uploader" action="/" :show-file-list="false"
                    :on-success="handleAvatarSuccess" :http-request="updataimg" :before-upload="beforeAvatarUpload">
                    <img v-if="FormData.showImg" :src="showImg" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </div>
              </div>
            </div>
            <div class="user_bnt_close" @click="addGroup">
              <div :class="isaddgroup?'active':''">
                发布
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <Pay v-show="pay" :pay ="pay" :qrcode_url="qrcode_url" @pay='pays'></Pay> -->
    <!-- <Pay v-show="pay" :qrcode_url="qrcode_url" :pay ="pay" @pay='pays' :moneyData="hongbaodata"></Pay> -->
  </div>
</template>

<script>
  import qs from "qs";
  import Pay from "./Pay.vue";
  import Nav from "./Nav.vue";
  import slide from './template_slide.vue'
  import moment from 'moment';
  import {
    userRelation,
    publish,
    roompublish,
    fansGroupImgUpload,
    anchorRecommendList,
    overaccount,
    recommendorder,
    recommendblock,
    recommendunblock,
    fansGroupcreate,
    userGroupList,
    notJoinGroupList
  } from "@/api/fans.js";
  export default {
    name: "App",
    data() {
      return {
        iscreateFansGroup:false,
        showdownAppindex:'',
        showImg:'',
        switchvalue: '',
        FormData: {
          title: '',
          introduction: '',
          showImg: '',
          entryCondition:1,
          entryConditionValue: '',
        },
        sheetData: [{
            title: '申请条件',
            show: false,
            sheetlist: [{
                name: '无限制',
                id: 1,

              },
              {
                name: '主播粉丝',
                id: 2,
              },
              {
                name: '用户等级',
                id: 3,

              }
            ],
          },
          {
            title: '最低等级',
            show: false,
            sheetlist: [{
                name: 5,
                id: 5,
              },
              {
                name: 10,
                id: 10,
              },
              {
                name: 15,
                id: 15,
              },
              {
                name: 20,
                id: 20,
              }
            ],
          }
        ],
        checkOrderIndex: 1,
        alert_order_seal: false,
        alert_order_over: false,
        alert_order_details: false,
        hitoryorderloading: '玩命加载中···',
        fansGroupList: [],
        nofansGroupList:[],
        hitoryorderindex: 1,
        changeTabsIndex: 5,
        b: 0,
        pay: false,
        token: "",
        personData: {},
        shenfenData: [],
        hongbaodata: [], //红包数据
        Mobile: "", //手机号
        qrcode_url: "",
        ExpPercentage: null, //经验条百分比
      };
    },
    filters: {
      fifphone(val) {
        if (!val) {
          return ''
        } else {
          val = String(val)
          let phone = val.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
          return phone;
        }

      }
    },
   computed:{
     isaddgroup(){
       if(this.FormData.title && this.FormData.introduction && this.FormData.entryCondition && this.FormData.showImg){
         return true
       }else{
         return false
       }
     }
   },
    created() {
      //页面加载时就从本地通过localstorage获取存储的token值
      this.token = localStorage.getItem("token");
      console.log(this.token);
      // 用户基本信息
      this.$store.dispatch('getUserInfoData').then((result) => {
          this.personData = result;
          this.getLishiTuidan()
          this.getlistnoGroup()
          this.ExpPercentage = Math.round(
            Math.round(
              (this.personData.userInfo.exp /
                this.personData.userInfo.nextLevelExp) *
              10000
            ) / 100.0
          );
        });
    },
    methods: {
      downloadApp(){
        const neww = this.$router.resolve({
          path: "/download",
          query: {
            rid: 9,
            infoId: 0,
            valId: 1
          },
        });
        window.open(neww.href, "_self");
      },
      fifadduser(val){
        if(val.entryCondition == 1){
          return '无限制'
        }
        if(val.entryCondition == 2){
          return '成为主播粉丝'
        }
        if(val.entryCondition == 3){
          return `用户等级达到${val.entryConditionValue}级以上`
        }
      },
      updataimg(val) {
        console.log('上传图片', val.file);
        let file = new FormData()
        file.append('file', val.file)
        fansGroupImgUpload(file).then(res => {
          console.log('上传结果', res)
          if (res.data.code == 200) {
            this.$message.success('上传成功')
            this.showImg =  'https://lz-fansgroup.oss-cn-hangzhou.aliyuncs.com/' + res.data.data
            this.FormData.showImg = res.data.data
          }
        })
      },
      addGroup(val) {
        let {title ,introduction,entryCondition,showImg ,entryConditionValue} = this.FormData;
        if(!title || title.trim() == ''){
          return this.$message.error('请输入群昵称')
        }
        if(!introduction || introduction.trim() == ''){
          return this.$message.error('请输入群公告')
        }
        if(!showImg || showImg.trim() == ''){
          return this.$message.error('请上传群头像')
        }
        if(entryCondition ==1){
          entryConditionValue = ''
          this.FormData.entryConditionValue  =''
        }
        console.log(this.FormData);

        fansGroupcreate({
          title:title,
          introduction:introduction,
          showImg:showImg,
          entryCondition:entryCondition,
          entryConditionValue:entryConditionValue,
        }).then(res=>{
          if(res.data.code == 200){
            this.$message.success('创建成功');
            // 关闭弹框
            this.alert_order_details = false;
            // 刷新数据
            this.getlistnoGroup()
            this.getLishiTuidan()
          }else{
            this.$message.success(res.data.message)
          }
        })

      },
      handleAvatarSuccess(res, file) {
        console.log(URL.createObjectURL(file.raw)); ;
      },
      beforeAvatarUpload(file) {
        console.log(file);
        const isJPG = file.type === 'image/jpeg' || file.type === "image/png" || file.type === "image/jpg";
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
      changeSlide(data) {
        this.$router.push(data);
      },
      collapseChange(e) {
        console.log(e);
        if (e || e === 0) {
          this.changeTabsIndex = e;

        }
      },
      handleChange(v, i) {
        console.log(v, i);
        this.changeTabsIndex = i;
        this.$router.push({
          path: v.path,
          params: {
            id: i,
            tab: 0
          }
        });
      },
      openDetails(item) {
        this.fanganContent = item;
        this.alert_order_details = true
      },
      // q确认结单
      overorderStatus() {
        overaccount({
          accountResult: this.checkOrderIndex, // 1：红，2：走，3：黑
          recommendId: this.fanganContent.recommendId, // 推单id
          accountScore: '', // 接单时比分
        }).then(res => {
          if (res.data.code == 200) {
            console.log('确认结单', res);
            this.alert_order_over = false;
            this.$message.success('结单成功')
            this.hitoryorderindex = 1
            this.getLishiTuidan()
          } else {
            this.$message.error(res.data.code)
          }
        })
      },
      sealOrder() {
        recommendblock({
          recommendId: this.fanganContent.recommendId
        }).then(res => {
          if (res.data.code == 200) {
            this.$message.success('封单成功');
            this.alert_order_seal = false
            this.hitoryorderindex = 1
            this.getLishiTuidan()
          } else {
            this.$message.error(res.data.message)
          }
        })
      },
      // 解除封单
      openOrderdata(val) {
        recommendunblock({
          recommendId: val.recommendId
        }).then(res => {
          if (res.data.code == 200) {
            this.$message.success('订单已经封单');
            this.hitoryorderindex = 1
            this.getLishiTuidan()
          } else {
            this.$message.error(res.data.message)
          }
        })
      },
      // 打开结单
      overOrderdata(val, item) {
        this.fanganContent = item;
        if (val) {
          this.alert_order_seal = true;
        } else {
          this.alert_order_over = true;
        }
      },
      loadorderlist() {
        this.getLishiTuidan()
      },
      fifTime(time) {
        // console.log('时间转换',time);
        return moment.unix(time).format('YYYY-MM-DD HH:mm:ss')
      },
      // 用户未加入的粉丝群
      getlistnoGroup(){
        notJoinGroupList({
          page:1,
          limit:500
        }).then(res=>{
          console.log('用户未加入的粉丝群',res);
          if(res.data.code == 200){
            this.nofansGroupList = res.data.data.list
          }
        })
      },
      // 用户相关的粉丝群列表
      getLishiTuidan() {
        if (localStorage.getItem("token")) {
          this.hitoryorderloading = '加载中···'
          let i = this.hitoryorderindex
          userGroupList().then((res) => {
            if (res.data.code == 200) {
              console.log('粉丝群列表',res);
              this.fansGroupList = res.data.data;
              if(this.fansGroupList.length >0){
                this.fansGroupList.map(item=>{
                  if(item.ownerUserData.uId == this.personData.userInfo.uid){
                      console.log('该主播创建了粉丝群');
                      this.iscreateFansGroup = true
                  }else{
                    console.log('该主播没有创建粉丝群');
                  }
                })
              }
              this.$forceUpdate()
            }
          });
        } else {
          // this.$message.error('请先登录后尝试')
        }
      },
      mobile(e) {
        this.Mobile = e;
      },
      //   提现
      Tixian() {
        this.$router.push("/wodeshouyi");
      },
      pays(e) {
        this.pay = e;
      },
      Chongzhi() {
        this.$refs.nevRef.Pay();
      },
      dianji(e) {
        this.b = e;
      },
      Mingcheng(e, item, i) {
        this.$router.push({
          name: item.path,
          params: {
            id: e,
            tab: i ? i : 0
          }
        });
      },
    },
    components: {
      Nav,
      Pay,
      slide
    },
  };
</script>

<style scoped lang='scss'>
  ::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 3px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 8px;
  }

  ::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    //background-color: #8c8c8c;
    background-color: rgba(0, 0, 0, 0.25);
  }

  ::-webkit-scrollbar-track {
    background-color: #f6f6f6;
  }

  ::-webkit-scrollbar-thumb,
  ::-webkit-scrollbar-track {
    border: 0;
  }

  .a {
    background-color: #721edc;
  }

  .personal-bottom-bottom-left .el-collapse-item__header {
    box-sizing: border-box;
    padding-left: 20px;
    background-color: #fff;
    border-bottom: 0px solid #ebeef5;
    color: #333;
  }

  .personal-bottom-bottom-left .is-active {
    color: rgba(114, 30, 220, 1);

  }

  .mask_bg {
    position: fixed;
    z-index: 2;
    background-color: rgba(0, 0, 0, .3);
    top: 0;
    height: 100vh;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .sael_order {
    position: absolute;
    right: 50%;
    top: 50%;
    transform: translate(50%, -50%);
    padding: 34px 22px;
    z-index: 10;
    width: 256px;
    height: 136px;
    box-sizing: border-box;
    background: #FFFFFF;
    box-shadow: 0px 2px 9px 0px rgba(46, 48, 52, 0.3);
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .close_downApp:hover{
      transform: rotate(180deg);
      transition: all 0.2s;
    }
    .close_downApp{
      position: absolute;
      transition: all 0.2s;
      top: 14px;
      right: 18px;
       width: 24px;
       height: 24px;
    }
    .s_title {
      flex: 2;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
    }

    .s_btn {
      display: flex;
      width: 100%;
      justify-content: space-around;
      user-select: none;

      span {
        width: 61px;
        cursor: pointer;
        text-align: center;
        line-height: 27px;
        height: 27px;
        font-size: 14px;
        background: #DADADA;
        border-radius: 90px;
      }
    }
  }

  .source_button {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;

    .source_cencal {
      flex: 1;
      cursor: pointer;
      height: 64px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-right: 1px solid rgba(0, 0, 0, .1);
    }

    .source_ok {
      flex: 1;
      cursor: pointer;
      height: 64px;
      display: flex;
      align-items: center;
      justify-content: center;

    }
  }

  .push_order_add {
    z-index: 2000;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 464px;
    box-sizing: border-box;
    background: #FFFFFF;
    box-shadow: 0px 2px 18px 0px rgba(0, 0, 0, 0.3);
    border-radius: 5px;
    padding: 22px;

    .user_bnt_close {
      margin-top: 36px;
      display: flex;
      justify-content: center;
      .active{
          background: #721EDC !important;
          color: #FFFFFF !important;
      }
      div {
        cursor: pointer;
        width: 161px;
        height: 39px;
        background: #F2F2F2;
        border-radius: 24px;
        text-align: center;
        line-height: 39px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333;
      }
    }

    .ptitles {
      margin-top: 18px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #333333;
    }

    .order_status {
      margin-top: 18px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .checkOrderdefault {
        background: #F4F4F4;
        transition: all .2s;
      }

      .statusImg {
        width: 109px;
        height: 109px;
        border-radius: 9px;
        padding: 14px;
        box-sizing: border-box;

        img {
          width: 80px;
          height: 80px;
        }
      }
    }

    .btnPay {
      margin-top: 50px;
      display: flex;
      justify-content: center;

      span {
        cursor: pointer;
        display: inline-block;
        text-align: center;
        width: 161px;
        height: 40px;
        line-height: 40px;
        background: #721EDC;
        border-radius: 24px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
      }
    }

    .peyorder {
      margin-top: 18px;
      padding: 14px 9px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #F4F4F4;
      border-radius: 5px;

      img {
        width: 16px;
        height: 16px;
      }
    }

    .paymoneys {
      margin-top: 18px;
      max-height: 104px;
      background: #F4F4F4;
      border-radius: 5px;
      padding: 0 10px;

      .pname {
        box-sizing: border-box;
        padding: 14px 0;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
        border-bottom: 1px solid rgba(0, 0, 0, .1);
      }

      .pmoney {
        padding: 14px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }

    .user_order_header {
      display: flex;
      align-items: center;
      margin-top: 18px;
      justify-content: space-between;

      .otest {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
      }

      .orderUsername {
        display: flex;
        align-items: center;

        img {
          margin-right: 8px;
          border-radius: 50%;
          width: 29px;
          height: 29px;
        }
      }
    }

    .order_Id {
      text-align: left;
      margin-top: 10px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }

    .btn_box_order {
      margin-top: 36px;
      display: flex;
      justify-content: space-around;

      .order_btns {
        width: 161px;
        cursor: pointer;
        height: 40px;
        border-radius: 24px;
        border: 1px solid #721EDC;
        text-align: center;
        line-height: 40px;
      }
    }

    .order_timePay {
      margin-top: 18px;
      display: flex;
      justify-content: space-between;

      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;

      .moneys {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFC000;
      }
    }

    .order_content_detail {
      margin-top: 18px;
      padding: 10px;
      max-height: 230px;
      word-wrap: break-word;
      overflow-y: scroll;
      background: #F4F4F4;
      border-radius: 5px;
      line-height: 24px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;


    }

    .order_box {
      display: flex;
      flex-direction: column;

      .message_small {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        margin-left: 92px;
        margin-top: 4px;
        color: #ED1010;
      }

      margin-top: 22px;

      .avatar-uploader {
        border-radius: 10px;
        background-color: #f3f3f3;
        overflow: hidden;
      }

      .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }

      .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
      }

     .avatar-uploader  .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
      }

      .avatar {
        width: 178px;
        height: 178px;
        display: block;
      }

      .add_group_item {
        display: flex;
        margin-top: 16px;
        box-sizing: border-box;
        align-items: center;

        .names {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          width: 90px;
          line-height: 16px;

        }

        .inputval {
          flex: 2;

          textarea {
            box-sizing: border-box;
            border-radius: 4px;
            padding: 12px;
            border: none;
            min-height: 80px;
            width: 100%;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            background: #F4F4F4;
            outline-style: none;
          }

          input {
            padding: 0 12px;
            color: #999999;
            border-radius: 4px;
            border: none;
            height: 40px;
            background: #F4F4F4;
            box-sizing: border-box;
            outline-style: none;
            width: 100%;
          }
        }
      }

      .hong {
        border: 1px solid red;
        color: #ED1010;
      }

      .lan {
        border: 1px solid #1076E9;
        color: #1076E9;
      }

      .tabs {
        width: 36px;
        height: 18px;
        border-radius: 4px;
        text-align: center;
        line-height: 18px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        margin-right: 6px;
      }

      .order_title {
        flex: 2;
        text-align: left;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
      }

      .order_status {
        font-size: 18px;
        margin-top: 0;

        span {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }
      }

    }

    .message_order_txt {
      margin-top: 18px;
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ED1010;
    }

    .btn_sumt {
      margin-top: 50px;
      display: flex;
      justify-content: center;

      .btn_active {
        background: #721EDC !important;
        color: #Fff;
      }

      span {
        cursor: pointer;
        text-align: center;
        width: 161px;
        height: 39px;
        line-height: 39px;
        background: #F2F2F2;
        border-radius: 24px;
      }

    }

    .from_order {
      margin-top: 18px;
      display: flex;
      align-items: center;

      .name_order {
        font-size: 16px;
        width: 50px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        margin-right: 34px;
      }

      .items_from_soft {
        width: 50px;
        height: 36px;
        cursor: pointer;
        background: #F4F4F4;
        border-radius: 4px;
        margin-right: 12px;
        line-height: 36px;
        text-align: center;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
      }

      .input_order_text {
        transform: translateY(-5px);
        height: 89px;
        width: 98%;

        textarea {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          padding: 9px 11px;
          border: none;
          outline-style: none;
          background: #F4F4F4;
          border-radius: 4px;
          box-sizing: border-box;
          min-width: 200px;
          width: 100%;
          height: 89px;
        }
      }

      .input_order {
        width: 100%;
        display: flex;
        max-width: 357px;
        height: 36px;
        border-radius: 4px;
        /* padding: 0 12px; */
        box-sizing: border-box;
        align-items: center;

        .order_soft_active {
          background: #721EDC !important;
          border-radius: 4px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF !important;
        }

        .el-radio {
          margin-right: 12px !important;


        }

        .is-checked {
          /deep/ .el-radio__inner {
            border-color: #721EDC !important;
            background: #721EDC !important;
          }

          /deep/ .el-radio__label {
            color: #721EDC !important;
          }
        }


        span {
          font-size: 16px !important;
        }

        .price_order {
          display: flex;
          align-items: center;
          margin-right: 11px;

          input {
            margin-right: 11px;
            width: 73px;
            padding: 0 12px;
            height: 36px;
            line-height: 36px;
            background: #F4F4F4;
            border-radius: 4px;
          }
        }

        input {
          padding: 0 12px;
          color: #999999;
          width: 100%;
          background: #F4F4F4;
          border: none;
          outline-style: none;
          max-width: 357px;
          height: 36px;
        }
      }
    }

    .order_headers {
      height: 22px;
      font-size: 22px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 22px;
      position: relative;
      text-align: center;

      .close_add_order {
        position: absolute;
        height: 22px;
        width: 22px;
        right: 20px;
        top: 0;
      }
    }
  }

  .personal-bottom-bottom-left .el-collapse-item__content {
    padding-bottom: 0px;
  }

  .personal-bottom-bottom-left .el-collapse-item__wrap {
    border-bottom: 1px solid #ebeef5 !important;
  }

  .personal-bottom-bottom-left .el-collapse-item__content>div {
    text-align: center;
  }

  .personal-bottom-bottom-left .el-collapse {
    border-top: 0px solid #ebeef5;
    width: 100%;
  }

  .personal-bottom-bottom-left .el-collapse-item__wrap {
    /* background-color: black; */
    color: #333;
  }

  .personal {
    width: 100vw;
    background: #f7f8fa;

    .xzcxzcxz {
      color: rgba(114, 30, 220, 1) !important;
    }


    .mydropdown {
      margin-top: 18px;
    }

    .personal-bottom {
      background-color: #f7f8fa;
    }

    .personal-bottom-top {
      width: 100%;
      height: 60px;
      min-width: 1240px;
      background-color: #fff;
    }

    .personal-bottom-top-div {
      width: 1240px;
      height: 60px;
      margin: 0 auto;
      color: #333;
      font-size: 23px;
      line-height: 60px;
      display: flex;
      align-items: center;
    }

    .personal-bottom-top-div-div {
      width: 6px;
      height: 50px;
      background-color: #721edc;
      border-radius: 6px;
    }
  }

  .personal-bottom-bottom {
    width: 1200px;
    height: calc(100vh - 105px);
    margin: 0 auto;
    display: flex;
    background-color: #f7f8fa;
    min-width: 1200px;

    .personal-bottom-bottom-left {
      width: 190px;
      height: 100%;
      background-color: #fff;
      margin-top: 16px;
      color: #333;

      .hiddenRight {
        /deep/ .el-collapse-item__arrow {
          display: none !important;
        }
      }

      .myel-collapse-item {
        width: 190px;
      }

      .prent_item {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        transition: all 1.2s;
        padding: 0 24px;

        .parent_icon {
          display: flex;
          align-items: center;
          margin-right: 4px;
          width: 18px;
          height: 18px;

          img {
            width: 18px;
            height: 18px;
          }
        }

        .actives {
          color: #721edc !important;
          font-size: 15px !important;
        }

        .parent_name {
          display: flex;
          transition: all 0.2s;
          align-items: center;
          font-size: 14px;
        }
      }

      .child_item {
        color: #a6a6a6;
        width: 100%;
        height: 52px;
        line-height: 52px;
        background-color: #f2f2f2;

        .child_img {
          display: flex;
          align-items: center;
        }

        .child_name {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          cursor: pointer;
        }
      }
    }
  }

  .title_box {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .lines {
      display: inline-block;
      width: 4px;
      margin-right: 6px;
      border-radius: 4px;
      height: 20px;
      background: #721edc;
    }

    span {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #333333;
    }
  }

  .personal-bottom-bottom-right {
    margin-left: 12px;
    height: 100%;
    width: 100%;
    max-width: 998px;
    padding: 16px 20px;
    box-sizing: border-box;
    background-color: #fff;
    padding: 30px 20px 0;
    box-sizing: border-box;
    overflow: hidden;
    .contentpage{
      padding-right: 20px;
      overflow-y: scroll;
      height: 94%;
      /* padding-bottom: 10px; */
    }
    .fansGroupbox {
      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;
  /*    .fansGroup_item:hover{
        .appContent{
          display: block !important;
          transition: all .2s;
        }
      } */

      .fansGroup_item:hover{
        box-shadow: 0px 0px 6px 0px rgba(114, 30, 220, 0.2);
        border: 1px solid rgba(0, 0, 0, 0);
      }
      .fansGroup_item {
        width: 463px;
        margin-top: 24px;
        height: 148px;
        background: #FFFFFF;
        cursor: pointer;
        border-radius: 6px;
        border: 1px solid #DADADA;
        padding: 24px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        position: relative;

        .appContent {
          position: absolute;
          display: block;
          right: 0;
          z-index: 1;
          bottom: 20px;
          width: 170px;
          height: 36px;
          background: rgba(0, 0, 0, .5);
          border-radius: 4px;
          text-align: center;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 36px;
        }

        .group_box {
          flex: 2;
          padding: 8px 0;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .addgroupgreeds {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
          }

          .discriptmsg {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
          }

          .group_title {
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: #333333;
          }
        }

        .fans_header {
          height: 100px;
          width: 100px;
          margin-right: 12px;
          border-radius: 50%;

          img {
            height: 100px;
            width: 100px;
          }
        }
      }
    }

    .myfans {
      margin-top: 12px;
      margin-bottom: 24px;

      span {
        font-size: 14rpx;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ED1010;
      }

      .addfanGroup {
        width: 130px;
        cursor: pointer;
        height: 36px;
        background: #721EDC;
        border-radius: 4px;
        text-align: center;
        margin-top: 12px;
        font-size: 14px;
        line-height: 36px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
      }
    }


    .user_push_order {
      padding: 12px 0;
      box-sizing: border-box;

      .scroll_orders {
        height: calc(100vh - 300px);
        overflow-y: scroll;

        .loadorder {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 46px;
          color: #666;
          background-color: rgba(0, 0, 0, .1);
        }
      }
    }

    .groupOrder {
      padding: 18px 0;

      .emittxt {
        min-height: 50vh;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;

        .emit {
          width: 164px;
          height: 94px;
          margin-bottom: 18px;
        }

        span {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
        }
      }

      .groupOrder_item {
        margin-bottom: 12px;
        width: 98%;
        /* height: 149px; */
        background: #FFFFFF;
        box-shadow: 0px 0px 9px 0px rgba(114, 30, 220, 0.2);
        border-radius: 5px;
        border: 1px solid #DADADA;

        /* 用户推单 */
        .user_order {
          cursor: pointer;
          display: inline-block;
          box-sizing: border-box;
          width: 100%;
          min-height: 158px;
          padding: 22px 12px;
          background: #FFFFFF;
          border-radius: 6px;
          border: 1px solid #DADADA;
          position: relative;

          .btn_box_order {
            display: flex;
            justify-content: space-around;

            .order_btns {
              width: 65px;
              height: 25px;
              border-radius: 13px;
              cursor: pointer;
              border: 1px solid #721EDC;
              text-align: center;
              line-height: 25px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #721EDC;
              margin-right: 10px;
            }
          }

          .order_time_pay {
            display: flex;
            margin-top: 10px;
            align-items: center;
            justify-content: space-between;

            .times {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #666666;
              margin-right: 20px;
            }

            .pay_content {
              font-size: 14px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #FFC000;
            }
          }

          .order_content {
            margin-top: 22px;
            max-width: 900px;
            width: 100%;
            height: 29px;
            background: #F4F4F4;
            border-radius: 4px;
            border-radius: 4px;
            box-sizing: border-box;
            padding: 0 6px;
            line-height: 29px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
          }

          .order_title_tab {
            margin-top: 22px;
            padding-bottom: 22px;
            display: flex;
            align-items: center;
            border-bottom: 1px solid rgba(0, 0, 0, .1);
            justify-content: space-between;

            .hong {
              border: 1px solid red;
              color: #ED1010;
            }

            .lan {
              border: 1px solid #1076E9;
              color: #1076E9;
            }

            .tabs {
              width: 36px;
              height: 18px;
              border-radius: 4px;
              text-align: center;
              line-height: 18px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              margin-right: 6px;
            }

            .order_title {
              flex: 2;
              text-align: left;
              font-size: 18px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #333333;
            }

            .order_status {
              font-size: 18px;

              span {
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
              }
            }
          }
        }
      }
    }

    .personal-bottom-bottom-right-top {
      background-color: #fff;
      display: flex;
      align-items: center;
    }

    .xinxi {
      display: flex;
      align-items: center;
      font-size: 24px;
    }
  }

  .personal-bottom-bottom-right-bottom {
    background-color: #fff;
    box-sizing: border-box;
  }

  .personal-bottom-bottom-right-bottom-top {
    margin-top: 22px;
    padding-bottom: 26px;
    display: flex;
    border-bottom: 1px solid #dadada;

    .bottom_progress {
      display: flex;
      margin-top: 6px;
      align-items: center;

      .home-top-longin-div-top-center {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .home-top-longin-div-top-center-left {
        display: flex;
        background: #ffffff;
        // box-shadow: 0px 2px 10px 0px rgba(46, 48, 52, 0.3);
        border-radius: 0px 0px 6px 6px;
        border-radius: 2px;
        text-align: center;
        /* border: 1px solid rgba(45, 143, 255, 1); */
        color: rgba(18, 115, 225, 1);
        font-size: 14px;
      }
    }

    .person_top {
      flex: 2;

      .person_grade {
        display: flex;
        align-items: center;
      }

      .person_name {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;

        .router_edit {
          width: 20px;
          height: 20px;
          margin-left: 4px;

          img {
            width: 20px;
            height: 20px;
          }
        }
      }

      .person_id {
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }

      .person_gradebox {
        margin-top: 5px;
        display: flex;
        width: 100%;
        justify-content: space-between;
      }

      .person_grade_img {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #721edc;
      }
    }

    .my_person_header {
      width: 70px;
      height: 70px;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 12px;

      img {
        width: 70px;
        height: 70px;
      }
    }
  }

  .personal-bottom-bottom-right-bottom-center1 {
    margin-top: 15px;
    border-bottom: 1px #dadada solid;

    .item_pays {
      display: flex;
      align-items: center;

      img {
        width: 40px;
        height: 40px;
        margin-right: 10px;
      }

      .titles {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 600;
        color: #333333;
      }

      span {
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }
    }

    .btn_intos {
      cursor: pointer;
      border-radius: 4px;
      text-align: center;
      line-height: 28px;
      width: 80px;
      height: 28px;
      background-color: #721edc;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
    }

    .price_item {
      font-size: 14px;
      color: rgba(213, 213, 213, 1);
    }

    .person_money {
      display: flex;
      margin-top: 20px;
      justify-content: space-between;
    }

    .person_money_item {
      margin-bottom: 30px;
      width: 460px;
      height: 60px;
      background: #f7f8fa;
      border-radius: 6px;
      display: flex;
      padding: 0 20px 0 10px;
      box-sizing: border-box;
      justify-content: space-between;
      align-items: center;
    }
  }

  .personal-bottom-bottom-right-bottom-center2 {
    margin-top: 15px;
    width: 100%;

    .userinfo_update {
      display: flex;
      flex-flow: row wrap;
    }

    .number_list {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 70px;
      width: 450px;
      margin-bottom: 30px;
      margin-right: 6%;
    }

    .number_list:nth-child(2n) {
      margin-right: 0 !important;
    }

    .phone_title {
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
    }

    .phone_number {
      margin-top: 6px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }

    .phone_img {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 10px;

      img {
        width: 70px;
        height: 70px;
      }
    }

    .update_phone {
      text-decoration: none;
      width: 130px;
      text-align: center;
      height: 36px;
      line-height: 36px;
      background: rgba(114, 30, 220, 1);
      border-radius: 4px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      // color: #666666;
      color: #fff;
    }

    .over_updata {
      color: #666666 !important;
      background: #f7f8fa !important;
    }

    .nophone_item {
      font-size: 16px;
    }

    .number_item {
      display: flex;
      align-items: center;
    }

    .items_tight {
      // margin-left: 14px;
      height: 100%;
    }
  }

  .biao {
    width: 16px;
    height: 16px;
    background-image: url(https://oss.ansongqiubo.com/assets/personimage/jiantou.png);
  }

  .colorBiao {
    background-image: url(https://oss.ansongqiubo.com/assets/personimage/jiantou1.png) !important;
  }

  .jingyantiao {
    width: 155px;
    margin: 0 4px;
    border-radius: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/component/fansGroup.vue